import React from "react";
import {Button, Grid2, Typography} from "@mui/material";
import {SentimentDissatisfied} from "@mui/icons-material";
import {useTranslation} from "react-i18next";
import {AuthI18N, CommonI18N} from "@/translations";
import {useNavigate} from "react-router-dom";

interface NotFoundProps {
    message?: string;
}

export const NotFound = ({ message }: NotFoundProps) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <Grid2
            container
            direction="column"
            justifyContent="center"
            alignItems="center"
            style={{ height: "50vh" }}
            spacing={2}
        >
            <Grid2>
                <SentimentDissatisfied sx={{ fontSize: 64, color: "text.secondary" }} />
            </Grid2>
            <Grid2>
                <Typography variant="h5" color="text.secondary" align="center">
                    {message || t(CommonI18N.message.resourceNotFound)}
                </Typography>
            </Grid2>
            <Grid2>
                <Button variant="outlined" onClick={() => navigate(-1)}>
                    {t(AuthI18N.login.action.back)}
                </Button>
            </Grid2>
        </Grid2>
    );
};
